import React from 'react';
import OverviewDashboard from './OverviewDashboard';

// RiskManagerDashboard — the home shown to the risk_manager role. It now renders
// the same org-wide analytics content as the Risk Admin overview
// (OverviewDashboard): greeting header, severity KPIs, exposure + category + top
// risks, trend + heatmap + treatment, and the BU/Project distribution tables.
// All data/actions arrive via props from the shell and are passed straight
// through.

export default function RiskManagerDashboard(props) {
    return <OverviewDashboard {...props} />;
}
